import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined';
import './consent-home.scss';
import './consents.scss';

import { Box } from '@mui/material';

interface ErrorDisplayParams {
  children: React.ReactNode;
}
export const ErrorDisplay = ({ children }: ErrorDisplayParams) => {
  return (
    <Box className="read-area">
      <div className="body">
        <div className="success-hero">
          <ErrorOutlineOutlinedIcon
            color="error"
            sx={{ width: '65px', height: '65px' }}
          />
          {children}
        </div>
      </div>
    </Box>
  );
};
